<template>
  <div>
    <div class="content_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main?lang=' + lang }">{{
          cooperation.title
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item, index) in brandList" :key="index">{{
          item.categoryName
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 幻灯片图片 -->
    <div v-if="banner !== null && banner.length > 0">
      <div class="content_carousel">
        <el-carousel :interval="5000" arrow="always">
          <el-carousel-item v-for="item in banner" :key="item.id">
            <img :src="item.imageUrl" :alt="item.operationName" @click="handleView(item.redirectUrl)"
              class="carouselImg" :style="cursorPointer(item.redirectUrl)" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 搜索检索 -->
    <div class="search-form">
      <el-form ref="examForm" :inline="true" :model="query" label-width="160px" class="examForm" @submit.native.prevent>
        <el-form-item label="" prop="courseName">
          <el-input v-model="query.problemName" autocomplete="off" style="width: 400px;"
            @keyup.enter.native="submitForm('examForm')" :placeholder="$t('problem.searchDefault')" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="custom-search-btn" @click="submitForm('examForm')">{{
            $t("search")
          }}</el-button>
          <el-button @click="resetForm('examForm')">{{
            $t("reset")
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="content_notification">
      <ul class="list-with-divider">
        <li style="height: 30px;font-weight: bold;" class="el-icon-caret-right">
          {{ $t('problem.contentTitle') }}
        </li>
        <!-- <li v-for="notice in items" :key="notice.id" style="padding-left: 20px; height: 30px; cursor: pointer;" @click="handleStartNotice(notice, lang)">
            {{ notice.title }}
          </li> -->
      </ul>
    </div>

    <div style="margin-left: 30px; cursor: pointer; font-weight: 600px;">
      <el-collapse v-model="activeName" v-for="notice in items" :key="notice.id">
        <el-collapse-item :title="'Q: ' + notice.title" :name="notice.id">
          <div class="list_content" style="margin-top: 15px;"> A : {{ notice.abstractContent }}
            <span v-if="notice.detail === 0" style="color: #00B5B1;font-family: 'Poppins', sans-serif;font-weight:normal;"
              @click="handleStartNotice(notice.id, lang)">&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('problem.contentTitleDetail') }}>>
            </span>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div>
      <el-row class="list-pagination" style="margin-right: 25px; margin-left: 25px">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
          :page-sizes="[10]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </el-row>
    </div>

  </div>
</template>

<script>
import { messageWarn } from '@/utils/util'
import 'element-ui/lib/theme-chalk/index.css'
import { switchLanguage } from "@/api/sigen/paginationLang";
import { listBase, listProblem } from "@/api/sigen/problemList";

export default {
  inject: ['getCateId'],
  data() {
    return {
      stepDescription1: '<p>富文本内容<strong>步骤一</strong><div @click="handleClick()">点击我</div></p> ',
      stepDescription2: '<p>富文本内容<strong>步骤二</strong>描述</p>',
      richButtonText: '<strong>加粗按钮</strong>',
      language: this.$i18n.locale,
      cooperation: '',
      breadFirst: '',
      breadSec: '',
      login: false,
      isLogin: 0,
      loginView: 0,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      lang: "en",
      bread: [],
      step: [],
      brandList: [],
      category: '',
      banner: [
        {
          id: 1,
          src: "https://www.sigenergy.com/static/0417/demo/sgp2install.webp",
          title: "xxx1",
          href: "detail/analysis"
        },
        {
          id: 2,
          src: "https://www.sigenergy.com/static/0417/demo/sgp2install.webp",
          title: "xxx2",
          href: "detail/count"
        },
        {
          id: 3,
          src: "https://www.sigenergy.com/static/0417/demo/sgp2install.webp",
          title: "xxx3",
          href: "detail/publish"
        },
        {
          id: 4,
          src: "https://www.sigenergy.com/static/0417/demo/sgp2install.webp",
          title: "xxx4",
          href: "detail/forecast"
        }
      ],
      items: [],
      isFavorited: false,
      isThumbUp: false,
      thumbUpCount: 0,
      activeName: ['1'],
      query: {
        problemName: ''
      }

    };
  },
  mounted() {
    console.log(">>>>>>>>>>>>>>>>>>>>>>>>  mounted  getCateId :  ", this.getCateId())
    // 根据不同路由跳转不同页面
    // if (this.isMobile()) {
    //   console.log("Mobile client");
    //   const url = "https://msupport.sigenergy.com/ ";
    //   // 打开新窗口
    //   window.open(url, '_self');
    // } else {
    //   console.log("PC client");
    // }
  },
  created() {
    let lang = this.getRouteParams();
    this.handleSetLanguage(lang);
    // this.checkLogin();
    this.lang = lang;
    this.switchLanguage(this.lang);
    this.listStepPull(this.isLogin, lang, this.getCateId());
    this.listNotificationPull(
      this.loginView,
      lang,
      this.pageNum,
      this.pageSize
    )
  },
  computed: {
  },
  methods: {
    switchLanguage(lang) {
      switchLanguage(lang)
    },

    submitForm() {
      this.query.pageSize = 1;
      this.listNotificationPull(
        this.loginView,
        this.lang,
        this.pageNum,
        this.pageSize
      );
    },
    resetForm() {
      this.query.problemName = "";
      this.listNotificationPull(
        this.loginView,
        this.lang,
        this.pageNum,
        this.pageSize
      );
    },
    cursorPointer(redirectUrl) {
      if (redirectUrl === null || redirectUrl === '' || redirectUrl === undefined) {
        return '';
      }
      return 'cursor: pointer;';
    },
    toggleThumbUp() {
      this.isThumbUp = !this.isThumbUp;
      if (this.isThumbUp) {
        this.thumbUpCount++;
      }
    },
    toggleFavorite() {
      // 切换收藏状态
      this.isFavorited = !this.isFavorited;

      // 这里可以添加实际的收藏逻辑，例如调用API保存到服务器
      // 模拟保存收藏逻辑
      console.log('收藏状态已保存:', this.isFavorited ? '已收藏' : '已取消收藏');
    },
    handleStartNotice(id, lang) {
      // this.$router.push({
      //   name: "problem-details",
      //   query: { noticeId: notice.id, lang: lang }
      // });
      var url = 'problem-details?noticeId=' + id + '&lang=' + lang;
      window.open(url, "_blank");
    },
    listStepPull(isLogin, lang, cateId) {
      if (lang === undefined) {
        return;
      }
      listBase(isLogin, lang, cateId).then((res) => {
        this.cooperation = res.data.result.cooperation;
        this.brandList = res.data.result.brandList;
        this.banner = res.data.result.banner;
      }).catch((error) => {
        console.error(error);
      });
    },
    handleView(linkUrl) {
      // file view
      window.open(linkUrl, "_blank");
    },
    handleClick() {
      alert('123456')
    },
    getRouteParams() {
      // 使用 let phone=this.$route.query.name 来获Get请求参数的值
      let lang = this.$route.query.lang;
      return lang;
    },
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.language = lang;
    },
    checkLogin() {
      if (this.userInfo.id !== undefined) {
        this.login = true;
        if (this.login) {
          this.isLogin = 0;
        } else {
          this.isLogin = 1;
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.listLoading) {
        messageWarn(this, this.$t("load.loading"));
        return;
      }
      this.listNotificationPull();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      if (this.listLoading) {
        messageWarn(this, this.$t("load.loading"));
        return;
      }
      this.listNotificationPull();
    },
    listNotificationPull() {
      listProblem(
        this.query.problemName,
        this.loginView,
        this.lang,
        this.pageNum,
        this.pageSize
      ).then((res) => {
        this.items = res.data.result.data;
        this.total = res.data.result.total;
        this.isLastPage = res.data.result.isLastPage;
        this.listLoading = false;
        this.activeName = res.data.result.listId;
      })
        .catch((_error) => {
          messageWarn(this, this.$t("load.noMoreData"));
          this.listLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.content_header {
  margin-left: 10px;
  line-height: 30px;
  margin-top: 20px;
}

.inline-div {
  display: inline;
  margin-right: 10px;
  /* 可以添加间距 */
}

.content_carousel {
  margin-left: 20px;
  margin-top: 17px;
  margin-right: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
  cursor: pointer;
}

.carouselImg {
  width: 100%;
  height: 100%;
  margin-right: 5px;
  border-radius: 4px;
}

/** 走马灯样式 */
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 260px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.content_notification {
  margin-left: 20px;
  margin-right: 30px;
  margin-top: 10px;
  font-size: 15px;
}

ul {
  list-style-type: none;
  /* 移除列表的标记 */
  padding: 0;
  /* 移除padding */
  margin: 0;
  /* 移除margin */
}

li {
  position: relative;
  /* 设置定位 */
  margin-bottom: 20px;
}

li:after {
  content: "";
  /* 使用:after伪元素添加内容 */
  position: absolute;
  /* 绝对定位 */
  left: 0;
  /* 从左边开始 */
  right: 0;
  /* 至右边结束 */
  bottom: 0;
  /* 定位至底部 */
  //border-bottom: 1px solid #ccc; /* 添加直线 */
}

.list-pagination {
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  margin: 1px 0 0px 0;
  background: #ffffff;
}

.list_content {
  margin-right: 30px;
  margin-left: 16px;
  margin-bottom: 12px;
}

.list_detail {
  margin-right: 30px;
  margin-left: 16px;
}

/* 新的CSS类，用于覆盖默认的搜索按钮样式 */
.custom-search-btn {
  background-color: #00B5B1;
  /* 修改为你想要的颜色 */
  border: 1px solid #00B5B1;
}

.search-form {
  margin-top: 30px;
  margin-left: 30px;
  margin-bottom: 10px;
  width: 105%;
  position: relative;
  /* 或 absolute, fixed, depending on layout needs */
  bottom: 0;
  /* 将div固定在父容器的底部 */
}
</style>


// WEBPACK FOOTER //
// src/components/sigen/problem/index.vue